import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const ProduktTypAttributeServiceConfig = {
  name: "ProduktTypAttribute",
  annotations: []
} as ServiceConfig;